import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import configData from "./config.json";
import Cookies from 'js-cookie';
var CryptoJS = require("crypto-js");

function Otp() {
  // eslint-disable-next-line
  const [otpError, setOtpError] = useState('');
  const [values, setValues] = useState(['','','','','','']);
  // eslint-disable-next-line
  const [apiSuccessMessage, setApiSuccessMessage] = useState('');
  // eslint-disable-next-line
  const [apiErrorMessage, setApiErrorMessage] = useState('');

  const navigate = useNavigate();

  const handlePasteAnywhere = (ev) => {
    if(document.getElementsByClassName('ap-otp-input').length > 0) {
      const clip = ev.clipboardData.getData('Text').trim();
      document.getElementById('OTP-digit-error').style.display='none';
      const s = [...clip];
      const arr = ['0','1','2','3','4','5','6','7','8','9'];
      let key = 1;
      s.forEach(i => {
        if(arr.includes(i)) {
          setOtpError('');
          if(key < 7) {
          document.getElementById('ot'+key).classList.remove('error');
          document.getElementById('ot'+key).value = i;
          document.getElementById('ot'+key).focus();
          }
          if(key > 7){
            document.getElementById('OTP-digit-error').style.display='block';
            document.getElementById('ot1').classList.add('error');
            document.getElementById('ot2').classList.add('error');
            document.getElementById('ot3').classList.add('error');
            document.getElementById('ot4').classList.add('error');
            document.getElementById('ot5').classList.add('error');
            document.getElementById('ot6').classList.add('error');
          }
        }else {
          document.getElementById('OTP-digit-error').style.display='block';
        }
        key=key+1;
      });
      if(/^\d+$/.test(clip)) {
        setTimeout(function() {
          if(!s.length > 6) {
            document.getElementById('ot'+(s.length+1)).focus();
          }
        }, 100);
      }
    }
  }

  const handleKeyUp = (ev) => {
    const i = parseInt(ev.target.id.replace("ot", ""));
    let iNext = i+1;
    if(iNext < 7) {
      if(document.getElementById(ev.target.id).value === '') {
        document.getElementById(ev.target.id).value = "";
      }else {
        document.getElementById('ot'+iNext).focus();
      }
    }
  }

  const handleKeyDown = (ev) => {
    const targetId = ev.target.id;
    const i = parseInt(ev.target.id.replace("ot", ""));
    let iPrevious = i-1;
    if(iPrevious > 0) {
      if (!document.getElementById(targetId).value && ev.key === "Backspace" && document.getElementById(targetId)) {
        document.getElementById('OTP-digit-error').style.display='none';
        document.getElementById('ot'+iPrevious).focus();
      }
    }
  }

  document.addEventListener('paste', handlePasteAnywhere);
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);

  const handleUpdateValues = (ev) => {
    if (!/\d/.test(document.getElementById('ot1').value)) {document.getElementById('ot1').value='';}
    if (!/\d/.test(document.getElementById('ot2').value)) {document.getElementById('ot2').value='';}
    if (!/\d/.test(document.getElementById('ot3').value)) {document.getElementById('ot3').value='';}
    if (!/\d/.test(document.getElementById('ot4').value)) {document.getElementById('ot4').value='';}
    if (!/\d/.test(document.getElementById('ot5').value)) {document.getElementById('ot5').value='';}
    if (!/\d/.test(document.getElementById('ot6').value)) {document.getElementById('ot6').value='';}
    let data=[document.getElementById('ot1').value,document.getElementById('ot2').value,document.getElementById('ot3').value,document.getElementById('ot4').value,document.getElementById('ot5').value,document.getElementById('ot6').value];
    setValues(data);
  }

  const validateOtp = async function () {
    setOtpError('');
    setApiErrorMessage('');
    if( values.indexOf('') > -1 ) {
      setOtpError('OTP entered is incorrect');
    }else {
      const FinalInputOtp = values[0] + values[1] + values[2] + values[3] + values[4] + values[5];
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email, otp: FinalInputOtp })
      };
      try {
        fetch(configData.SERVER_URL+"/submitOTP", requestOptions)
          .then(response => {
            return response.json()
          })
          .then(results => {
            if (results.success === true) {
              if (results.data.status === true) {
                Cookies.remove('emailAuthenticated');
                Cookies.remove('otp');
                Cookies.set('status', true, { expires: 7 });
                navigate("/dashboard");
              } else {
                setApiErrorMessage(results.message);
              }
            } else {
              setApiErrorMessage(results.message);
            }
            
          })
        return true;
      } catch (error) {
        setApiErrorMessage('Something went wrong. Please Try Again.');
        return false;
      }
    }
  };

  const handleBackToLogin = () => {
    navigate("/");
  }

  const keyDownHandler = event => {
    if (event.key === 'Enter') {
      console.log('Enter Key Pressed')
      event.preventDefault();
      validateOtp();
    }
  }

  const backToLoginPage = () => {
    sessionStorage.setItem("flashEmail", JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email);
    navigate("/");
  }

  if (Cookies.get('emailAuthenticated') && !Cookies.get('status')) {
  return (
    <div className="d-flex bg_main justify-content-between">
      <div className="login_content">
        <div className="login_text">
          <h2 className="login_heading">Harnessing Data to Drive Smarter Advertising Decisions.</h2>
          <p>Elevate Your Website's Ad Placement Strategy with<br /> Advanced Analytics.</p>
        </div>
        <div className="login_img">
          <img src="assets/media/images/login_img.svg" alt="login" />
        </div>
      </div>

      <div className="login_form d-flex align-items-center justify-content-center">
        <div className="login_form_inner">
          <div className="card_content">
            <div className="form_group">
              <h1 className="mb_12px">Confirm OTP</h1>
              <p className="text_dark mb_49px">
                Enter the OTP sent on &nbsp;
                <span className="text_primary">
                  {JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email}
                </span>
                  <div className="btn-icon btn back_btn" onClick={handleBackToLogin}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.01929 11.9251H12.25" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M7.455 2.21363C7.90746 1.67288 8.72083 1.59358 9.2728 2.03684C9.30332 2.06089 10.2839 2.82263 10.2839 2.82263C10.8902 3.1892 11.0787 3.96848 10.7038 4.56318C10.6839 4.59502 5.1403 11.5293 5.1403 11.5293C4.95587 11.7594 4.6759 11.8952 4.3767 11.8984L2.25372 11.9251L1.77539 9.90052C1.70839 9.61584 1.77539 9.31687 1.95983 9.08679L7.455 2.21363Z" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M6.42871 3.50049L9.60919 5.94298" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
              </p>
            </div>
            <div className="form_group">
              <div className="ap-otp-inputs otp-input-fields d-flex justify-content-between" data-username="otibij"
                data-channel="email" data-nonce="0-8bf87e338f" data-length="6" data-form="registration">
                {['', '', '', '', '', ''].map((value, index) => (
                  <input key={index} id={'ot'+(index+1)} className={(values[index]) ? 'ap-otp-input otp__digit otp__field__1 active' : 'ap-otp-input otp__digit otp__field__1'} type="tel" maxLength="1" data-index={index} value={values[index]} onChange={handleUpdateValues} onBlur={handleUpdateValues} onKeyDown={keyDownHandler} />
                ))}
              </div>
              <span className="error" id="OTP-digit-error" style={{display: 'none'}}>OTP can not be greater than 6 digits & contains only numeric digits.</span>
              <span className="error mb-0">{(apiErrorMessage)? apiErrorMessage: otpError}</span>
            </div>
            <div className="form_group mb_36px">
              <button className="loginModeBtn otpBtn" type="button" onClick={backToLoginPage}>Sign in using Password</button>
            </div>
            <div className="form_group mb-0">
              <button type="button" className="btn_primary" onClick={() => validateOtp()}>Submit</button>
            </div>
            <span className="success">{apiSuccessMessage}</span>
          </div>
        </div>
      </div>
    </div>
  );
  } else {
    window.location.href = "/";
  }
}

export default Otp;